import { AssistantOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

const AskGXButton = ({
  onClick
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <Button
      color='primary'
      sx={{
        height: 48,
        whiteSpace: 'nowrap',
        minWidth: 192,
        fontSize: '16px'
      }}
      variant='contained'
      onClick={onClick}
    >
      <AssistantOutlined
        sx={{
          width: '24px',
          height: '24px'
        }}
      />
      GX Go Assistant
    </Button>
  );
};

export default AskGXButton;
